import * as React from 'react';
import { renderFilArianne, renderTitleH1} from './RenderCommon';
import RenderFormIban from "./RenderFormIBAN";
export default class RenderDocuments extends React.Component<Record<string, unknown>, Record<string, unknown>> {
  constructor(props: Record<string, unknown>) {
    super(props);
  }

  render() {
    const render = () => {
      return (
          <div>
            <h3 className="font20">Ajout d'un compte bancaire</h3>
            <p>Cette fonctionnalité est disponible afin de nous permettre d'effectuer un remboursement par virement.</p>
            <RenderFormIban/>
          </div>
      );
    };
    return (
        <div>
          {renderTitleH1('', 'Facturation / Documents')}
          {renderFilArianne('', 'Facturation / Documents')}
          {render()}
        </div>
    );
  }
}
